module.exports = __webpack_public_path__ + "media/application/images/svgs/shuffle-a4ce8c1c1176ed83a89536eac30b4822.svg";